import { useContext, useMemo } from 'react';
import { CommonDataContext } from 'app/provider/CommonDataProvider';
import { formatHeaderFooterData } from './utils';

export function useNavigationData() {
  const { navigation } = useContext(CommonDataContext)!;
  const { data: headerFooterData } = navigation;

  return useMemo(() => formatHeaderFooterData(headerFooterData), [headerFooterData]);
}
